/* LA DIVINE — Estimateur de frais de livraison par code postal (D3).
   PRINCIPE : aucun prix / description en dur. Source = /cart/shipping_rates.json sur le panier réel.
   Sélection (CAS 2) : filtrer par FORMAT via le NOM du tarif (panier avec PM → tarifs « pièce montée » ;
   sinon les autres), puis le MOINS CHER. [] => encart hors-zone.
   B10 — DÉLÉGATION D'ÉVÉNEMENTS : un seul listener au niveau `document` par type (input/click/keydown/blur),
   qui résout SON instance (`closest('ld-shipping-estimator')`) et SON scope au moment de l'événement.
   Survit par construction à tous les re-rendus / morphs du drawer (Section Rendering API) → plus aucune
   ré-initialisation ni MutationObserver. Multi-instances (page ET drawer) : chaque event cible le
   conteneur le plus proche, donc SON propre total. */
(function () {
  'use strict';
  /* Prefixe de locale (27/08) : un appel Ajax panier a la racine part en redirection vers
     /fr-fr/... a chaque synchro. Shopify.routes.root vaut '/fr-fr/' sur une page FR. */
  function ldRacine() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function isPMname(name) { return norm(name).indexOf('montee') >= 0; }
  function cartHasPM(cart) {
    return (cart.items || []).some(function (it) {
      var h = norm(it.handle), pt = norm(it.product_type);
      return h.indexOf('piece-montee') >= 0 || h.indexOf('montee') >= 0 || pt.indexOf('mont') >= 0;
    });
  }

  // Contexte d'une instance, résolu à la volée (aucun état capturé au chargement).
  function ctx(root) {
    var en = root.getAttribute('data-en') === '1';
    return {
      root: root,
      scope: root.parentElement || document,
      en: en,
      input: root.querySelector('[data-ld-cp]'),
      resultEl: root.querySelector('[data-ld-result]'),
      outEl: root.querySelector('[data-ld-out]'),
      errEl: root.querySelector('[data-ld-err]'),
      t: { free: en ? 'Free delivery' : 'Livraison offerte', shipLabel: en ? 'Delivery' : 'Livraison',
           attente: en ? 'Estimating…' : 'Estimation en cours…',
           indispo: en ? 'Estimate unavailable right now. Please try again in a moment.' : 'Estimation indisponible pour le moment. Réessayez dans un instant.' }
    };
  }
  /* 24/09 — RÉSOLUTION VIVANTE. Le tiroir du panier est re-rendu par le thème (Section Rendering)
     à chaque synchronisation (Pickeasy, suppléments) : entre un clic et une réponse différée, la
     racine de l'estimateur peut avoir été REMPLACÉE. Écrire dans l'ancienne = n'afficher rien.
     On retrouve donc, au moment d'afficher, l'instance vivante du même emplacement (tiroir ou
     page) et on lui reporte le CP en cours. */
  function vivant(c) {
    if (document.contains(c.root)) return c;
    var dansTiroir = !!c.root.closest('cart-drawer, .cart-drawer, dialog');
    var roots = Array.prototype.slice.call(document.querySelectorAll('ld-shipping-estimator'));
    var r = roots.filter(function (x) { return !!x.closest('cart-drawer, .cart-drawer, dialog') === dansTiroir; })[0] || roots[0];
    if (!r) return c;
    r._ldZip = c.root._ldZip;
    var n = ctx(r);
    if (n.input && !n.input.value) n.input.value = c.root._ldZip || '';
    return n;
  }
  function showNote(c, texte) {
    if (c.outEl) c.outEl.hidden = true;
    clearInjectedTotal(c);
    if (c.resultEl) { c.resultEl.innerHTML = '<span class="ld-ship__head ld-ship__note">' + texte + '</span>'; c.resultEl.hidden = false; }
  }
  function fmtEUR(en, major) { var s = (Math.round(major * 100) / 100).toFixed(2); return en ? '€' + s : s.replace('.', ',') + ' €'; }
  function showErr(c, on) { if (c.errEl) c.errEl.hidden = !on; }

  function clearInjectedTotal(c) {
    c.scope.querySelectorAll('.ld-ship-line').forEach(function (n) { n.remove(); });
    var tv = c.scope.querySelector('[ref="cartTotal"], [data-testid="cart-total-value"]');
    if (tv && tv.dataset.ldBase) { tv.textContent = tv.dataset.ldBase; delete tv.dataset.ldBase; }
  }
  function injectTotal(c, rate, cartTotalCents) {
    var container = c.scope.querySelector('.cart-totals__container');
    var totalRow = container && container.querySelector('.cart-totals__total');
    var tv = c.scope.querySelector('[ref="cartTotal"], [data-testid="cart-total-value"]');
    if (!container || !totalRow || !tv) return;
    clearInjectedTotal(c);
    var shipCents = Math.round(parseFloat(rate.price) * 100);
    var shipTxt = shipCents === 0 ? c.t.free : fmtEUR(c.en, shipCents / 100);
    var line = document.createElement('span');
    line.className = 'cart-totals__item ld-ship-line cart-primary-typography';
    line.innerHTML = '<span class="ld-ship-line__label">' + c.t.shipLabel + '</span>' +
      '<span class="ld-ship-line__value cart-secondary-typography">' + shipTxt + '</span>';
    totalRow.parentNode.insertBefore(line, totalRow);
    if (!tv.dataset.ldBase) tv.dataset.ldBase = tv.textContent;
    tv.textContent = fmtEUR(c.en, (cartTotalCents + shipCents) / 100);
  }
  function showRate(c, rate, cents) {
    if (c.outEl) c.outEl.hidden = true;
    var price = parseFloat(rate.price);
    var head = price === 0 ? c.t.free : (rate.name + ' — ' + fmtEUR(c.en, price));
    var desc = rate.description ? '<span class="ld-ship__desc">' + rate.description + '</span>' : '';
    if (c.resultEl) { c.resultEl.innerHTML = '<span class="ld-ship__head">' + head + '</span>' + desc; c.resultEl.hidden = false; }
    injectTotal(c, rate, cents);
  }
  function showOut(c) { if (c.resultEl) c.resultEl.hidden = true; clearInjectedTotal(c); if (c.outEl) c.outEl.hidden = false; }
  function clearAll(c) { if (c.resultEl) c.resultEl.hidden = true; if (c.outEl) c.outEl.hidden = true; clearInjectedTotal(c); }

  function clean(c) {
    if (!c.input) return '';
    var v = (c.input.value || '').replace(/\D/g, '').slice(0, 5);
    c.input.value = v; c.root._ldZip = v; return v;
  }
  function estimate(c, zip, tentative) {
    Promise.all([
      fetch(ldRacine() + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }),
      fetch(ldRacine() + 'cart/shipping_rates.json?shipping_address[zip]=' + encodeURIComponent(zip) + '&shipping_address[country]=FR', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
    ]).then(function (res) {
      if (zip !== c.root._ldZip) return; // course : le CP a changé entre-temps
      c = vivant(c);
      var cart = res[0] || {};
      var rates = (res[1] && res[1].shipping_rates) || [];
      /* 24/09 — « Nous ne livrons pas encore votre secteur » est un verdict NÉGATIF montré au
         client : il exige une réponse positivement connue. Deux cas produisent une liste vide
         sans que le secteur soit refusé : un panier Ajax sans article (l'endpoint répond []
         quel que soit le CP), et une lecture pendant une resynchronisation du panier (Pickeasy,
         suppléments). Reproduit le 24/09 sur 75004 avec un panier vide. Panier vide → on
         n'affiche rien ; liste vide sur panier non vide → une seconde lecture 1,5 s plus tard
         avant de conclure. Un CP réellement retiré répond [] deux fois : verdict inchangé. */
      if (!(cart.items || []).length) { showNote(c, c.t.indispo); return; }
      if (!rates.length) {
        if (!tentative) { showNote(c, c.t.attente); setTimeout(function () { if (zip === c.root._ldZip) estimate(c, zip, true); }, 1500); return; }
        showOut(c); return;
      }
      var hasPM = cartHasPM(cart);
      var pool = rates.filter(function (r) { return isPMname(r.name) === hasPM; });
      if (!pool.length) pool = rates;
      var best = pool.reduce(function (a, b) { return parseFloat(b.price) < parseFloat(a.price) ? b : a; });
      showRate(c, best, typeof cart.total_price === 'number' ? cart.total_price : 0);
    }).catch(function () {
      /* 24/09 — réponse indéterminée (réseau, 429, JSON illisible) : on le DIT au client au lieu
         de se taire. « Ne rien afficher » n'est pas mieux qu'un message faux. */
      if (zip !== c.root._ldZip) return;
      c = vivant(c);
      showNote(c, c.t.indispo);
    });
  }

  // ---- DÉLÉGATION : listeners uniques sur document (attachés une fois, survivent à tout re-render) ----
  function rootFrom(e) {
    var el = e.target;
    if (!el || !el.closest) return null;
    return el.closest('ld-shipping-estimator');
  }
  function inputRoot(e) {
    var el = e.target;
    if (!el || !el.closest) return null;
    var input = el.closest('[data-ld-cp]');
    return input ? input.closest('ld-shipping-estimator') : null;
  }

  // Saisie : auto dès 5 chiffres (debounce ~300ms), masque l'erreur pendant la frappe.
  document.addEventListener('input', function (e) {
    var root = inputRoot(e); if (!root) return;
    var c = ctx(root);
    showErr(c, false);
    var v = clean(c);
    if (v.length < 5) { clearAll(c); return; }
    clearTimeout(root._ldTimer);
    root._ldTimer = setTimeout(function () { estimate(c, v); }, 300);
  });

  // Bouton « Estimer » (clic/tap) — affordance principale (clavier iOS sans Entrée).
  document.addEventListener('click', function (e) {
    var el = e.target; if (!el || !el.closest) return;
    var btn = el.closest('[data-ld-estimate]'); if (!btn) return;
    var root = btn.closest('ld-shipping-estimator'); if (!root) return;
    var c = ctx(root);
    clearTimeout(root._ldTimer);
    var v = clean(c);
    if (v.length === 5) { showErr(c, false); estimate(c, v); if (c.input) c.input.blur(); }
    else { showErr(c, true); if (c.input) c.input.focus(); }
  });

  // Entrée (clavier physique desktop).
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.keyCode !== 13) return;
    var root = inputRoot(e); if (!root) return;
    e.preventDefault();
    var c = ctx(root);
    clearTimeout(root._ldTimer);
    var v = clean(c);
    if (v.length === 5) { showErr(c, false); estimate(c, v); } else { showErr(c, true); }
    if (c.input) c.input.blur();
  });

  // Blur (focusout bulle jusqu'au document) : si 5 chiffres présents, on estime.
  document.addEventListener('focusout', function (e) {
    var root = inputRoot(e); if (!root) return;
    var c = ctx(root);
    var v = clean(c);
    if (v.length === 5) { showErr(c, false); estimate(c, v); }
  });

  // Panier modifié : ré-estimer les instances qui ont déjà un CP à 5 chiffres.
  document.addEventListener('cart:update', function () {
    document.querySelectorAll('ld-shipping-estimator').forEach(function (root) {
      if ((root._ldZip || '').length === 5) estimate(ctx(root), root._ldZip);
    });
    modeReception();
  });

  /* ── MODE RETRAIT — l'estimateur n'a plus de sens (27/08) ────────────────────────────────
     Défaut relevé dans le tiroir panier : « Calculez vos frais de livraison » + champ Code
     postal + bouton ESTIMER restaient affichés alors que « Retrait en boutique » était
     sélectionné. On masque l'estimateur (page ET tiroir) dès que le mode de réception vaut
     retrait.
     Source d'état : l'attribut de panier `Order Fulfillment Type`, qui contient « pickup »
     en retrait — c'est exactement le test que fait déjà S1 module 2 pour calculer son `mode`.
     `pickeasyData.fulfillmentType` sert d'accélérateur avant que le panier ne soit synchronisé.
     Prudence : en cas de doute on AFFICHE (l'inverse du garde-fou checkout — ici masquer à tort
     priverait le client d'une information, sans rien casser d'irréversible). */
  /* RÉVISION DU 02/09 — la version du 27/08 ne se déclenchait pas chez Simon.
     Deux défauts, corrigés ensemble :
       1. Elle ne regardait le panier qu'à 600, 1800 et 3500 ms, plus sur les `change` remontant
          au document. Or le client choisit son mode BIEN plus tard, et le widget Pickeasy ne
          renvoie pas forcément d'événement que l'on puisse capter. On observe donc en continu.
       2. Elle était binaire : « retrait ou pas ». Il faut trois états, parce que « je ne sais
          pas » et « livraison » n'appellent pas la même chose sur le rappel d'onglet. */

  /** 'retrait' | 'livraison' | 'inconnu' — jamais de valeur par défaut déguisée en certitude. */
  function modeDePanier(cart) {
    var signaux = [];
    var d = window.pickeasyData;
    if (d && typeof d.fulfillmentType === 'string' && d.fulfillmentType) signaux.push(d.fulfillmentType);
    var a = (cart && cart.attributes) || {};
    ['Order Fulfillment Type', 'Fulfillment Type', 'Delivery Method'].forEach(function (cle) {
      if (a[cle]) signaux.push(String(a[cle]));
    });
    for (var i = 0; i < signaux.length; i++) {
      /* « pickup » d'abord : « Local Delivery » contient « delivery », mais rien ne contient
         « pickup » sans être un retrait. */
      if (/pickup|retrait|collect|store/i.test(signaux[i])) return 'retrait';
      if (/delivery|livraison|shipping|expedi/i.test(signaux[i])) return 'livraison';
      /* Valeur non vide qu'on ne reconnaît pas. MESURÉ le 03/09 dans la console de Simon :
         Pickeasy renseigne `pickeasyData.fulfillmentType` et vaut « Local Delivery » en
         livraison. Le mode étant binaire chez Pickeasy, une valeur renseignée qui n'est pas
         une livraison est un retrait. On tranche donc plutôt que de rester « inconnu ». */
      if (signaux[i].trim()) return 'retrait';
    }
    return 'inconnu';
  }

  /* ARBITRAGE DE SIMON, 03/09 — les deux éléments basculent désormais sur le MÊME test :
     « le retrait est-il POSITIVEMENT établi ? ». L'état 'inconnu' se comporte comme une
     livraison, pas comme un retrait.

       · estimateur : masqué uniquement sur 'retrait'  -> visible en 'livraison' ET en 'inconnu'
       · rappel     : affiché uniquement sur 'retrait' -> masqué en 'livraison' ET en 'inconnu'

     La raison est une asymétrie de coût, et elle est de Simon : « le coût d'un rappel manquant
     est un clic ; le coût d'un estimateur masqué est un client qui ne sait pas ce qu'il va
     payer. » La version du 02/09 affichait le rappel dans le doute — un bruit permanent pour
     les clients en livraison, qui sont la majorité. */
  /* PLACEMENT DU RAPPEL — 02/09 (soir), GO Simon.
     Le paragraphe vit dans le thème, sous le récapitulatif. Quand le widget Pickeasy est rendu,
     on le déplace JUSTE SOUS ses deux boutons Livraison / Retrait (#ft-options-div), là où le
     regard est au moment du choix. Deux précautions :
       · Pickeasy peut re-rendre son HTML (changement de mode, resynchronisation) et DÉTACHER le
         paragraphe : on garde nos propres références (registre) au lieu de re-chercher dans le
         DOM, et à chaque passage on le remet, soit sous les boutons, soit à sa place d'origine.
       · Le tiroir et la page peuvent porter chacun un rappel ET un widget ; #ft-options-div est
         donc potentiellement dupliqué. On choisit celui de la MÊME zone (tiroir / récapitulatif)
         que le rappel, jamais le premier venu.
     Si le widget ne se rend pas, le paragraphe reste où il est : repli sans effet visible. */
  var rappels = [];
  function collecterRappels() {
    document.querySelectorAll('[data-ld-pickup-notice]').forEach(function (p) {
      if (rappels.indexOf(p) === -1) {
        p._ldOrigine = { parent: p.parentNode, suivant: p.nextSibling };
        rappels.push(p);
      }
    });
    return rappels;
  }
  function zoneDe(p) {
    var o = p._ldOrigine && p._ldOrigine.parent;
    return (o && o.closest && o.closest('cart-drawer, .cart-summary, form')) || document;
  }
  function placerRappel(p) {
    var zone = zoneDe(p);
    var cible = zone.querySelector('[id="ft-options-div"]');
    if (cible && document.contains(cible)) {
      if (p.previousElementSibling !== cible || p.parentNode !== cible.parentNode) {
        cible.insertAdjacentElement('afterend', p);
        p.setAttribute('data-ld-place', 'widget');
      }
      return;
    }
    var o = p._ldOrigine;
    if (!document.contains(p) && o && o.parent && document.contains(o.parent)) {
      if (o.suivant && o.suivant.parentNode === o.parent) o.parent.insertBefore(p, o.suivant);
      else o.parent.appendChild(p);
      p.removeAttribute('data-ld-place');
    }
  }

  function appliquer(mode) {
    var retrait = mode === 'retrait';
    document.querySelectorAll('ld-shipping-estimator').forEach(function (root) {
      root.hidden = retrait;
      root.style.display = retrait ? 'none' : '';
    });
    collecterRappels().forEach(function (p) {
      placerRappel(p);
      p.hidden = !retrait;
    });
  }

  function pertinent() {
    return !!document.querySelector('ld-shipping-estimator, [data-ld-pickup-notice]');
  }

  function lirePanier() {
    var racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(racine + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; });
  }

  var enVol = false;
  function modeReception() {
    if (enVol || !pertinent()) return;
    enVol = true;
    lirePanier()
      .then(function (cart) { appliquer(modeDePanier(cart)); })
      .catch(function () { /* doute => on ne touche à rien */ })
      .then(function () { enVol = false; });
  }

  /** Sonde de diagnostic. À exécuter dans la console si le comportement paraît faux :
   *    await window.__ldRetrait()
   *  Renvoie ce que le script VOIT réellement, pour ne pas avoir à le deviner. */
  window.__ldRetrait = function () {
    return lirePanier().then(function (cart) {
      var d = window.pickeasyData;
      return {
        mode: modeDePanier(cart),
        attributsPanier: (cart && cart.attributes) || null,
        pickeasyFulfillmentType: d ? d.fulfillmentType : '(pickeasyData absent)',
        estimateurMasque: !!document.querySelector('ld-shipping-estimator[hidden]'),
        rappelMasque: !!document.querySelector('[data-ld-pickup-notice][hidden]'),
        rappelPlace: collecterRappels().map(function (p) {
          return (p.getAttribute('data-ld-place') || 'origine') + (document.contains(p) ? '' : ' (DÉTACHÉ)');
        }),
      };
    });
  };

  document.addEventListener('change', modeReception, true);
  document.addEventListener('click', modeReception, true);
  document.addEventListener('visibilitychange', modeReception);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', modeReception);
  else modeReception();
  [600, 1800, 3500].forEach(function (d) { setTimeout(modeReception, d); });
  /* L’économie de requêtes ne concerne que le SONDAGE périodique : un onglet en arrière-plan
     n’a rien à recalculer tant que rien ne bouge. Les appels déclenchés par un événement ou par
     le chargement, eux, doivent toujours aboutir — sinon un onglet ouvert en arrière-plan garde
     un affichage faux jusqu’à ce que le client interagisse. */
  setInterval(function () { if (!document.hidden) modeReception(); }, 2500);
})();
